import Header from "./Header";
import About from "./About";
import Team from "./Team";
import Events from "./Events";
import Sponsors from './Sponsors';
import Footer from "./Footer";

const Home = () => {

  return (
    <>
      <Header />
      <About />
      <Team />
      <Events />
      <Sponsors />
      <Footer />
    </>
  )
}

export default Home;